import React from 'react'
import Skeleton from 'react-loading-skeleton'
import { match, useHistory, useRouteMatch } from 'react-router-dom'

import { bemJoin } from 'bem-join'

import {
  AlertType,
  useNotifications
} from '@app/common/services/Notifications/NotificationsProvider'
import { useIntl } from '@app/intl/Intl'
import { Select } from '@app/lib/inputs/Select'
import { getCourtCasePath } from '@app/modules/CourtCases'
import { useCoveredCourtCasesQuery } from '@app/queries/CourtCases/useCoveredCourtCasesQuery'

import './CourtCaseSelector.scss'

export const CourtCaseSelector = () => {
  const b = bemJoin('court-case-selector')
  const { formatMessage } = useIntl()
  const match: match<{ id: string; courtCaseUuid: string }> = useRouteMatch()
  const customerId = Number(match.params.id)
  const courtCaseUuid = match.params.courtCaseUuid
  const history = useHistory()
  const { pushNotification } = useNotifications()

  const { data, loading } = useCoveredCourtCasesQuery(customerId, {
    onError: (error) => {
      pushNotification({
        type: AlertType.error,
        message: error.message
      })
    }
  })

  const handleCourtCaseChange = (selectedUuid?: string) => {
    if (!selectedUuid) return

    history.push(getCourtCasePath(customerId, selectedUuid))
  }

  if (loading) {
    return <Skeleton />
  }

  const getSelectOptions = () => {
    const courtCases = data?.courtCases?.items || []

    return courtCases.map((courtCase) => {
      const date = new Date(courtCase.createdAt).toLocaleDateString('de-DE', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      })
      const baseLabel = formatMessage({ id: 'CourtCases.CourtCaseSelector.Label' }, { date })
      const stateLabel = formatMessage({ id: `CourtCases.State.${courtCase.state}` })
      return {
        value: courtCase.uuid,
        label: `${baseLabel} | ${courtCase.topic.name} | ${stateLabel}`
      }
    })
  }

  const selectOptions = getSelectOptions()

  return (
    <div className={b()}>
      <Select
        className={b('select')}
        triggerSize='sm'
        value={courtCaseUuid || ''}
        onChange={handleCourtCaseChange}
        options={selectOptions}
        disabled={loading || !data?.courtCases?.items.length}
      />
    </div>
  )
}
